/* eslint-disable react/display-name */
import * as React from 'react';

const CountryDe = () => (
  <>
    <svg
      version="1.1"
      id="Ebene_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 60 60"
      xmlSpace="preserve"
    >
      <g id="Page-1_1_">
        <g id="Händlerseite_tabelt_TAB2" transform="translate(-43.000000, -7.000000)">
          <g id="Header" transform="translate(-3.000000, 0.000000)">
            <g id="Group-9" transform="translate(46.000000, 7.000000)">
              <g id="Page-1">
                <path
                  className="st0"
                  d={`M24.6,11.6l-3-0.3l-5.8,1.5l0.6,3.4L16,18.7l-1.7,1.6l1.2,1.7l-1.4,2.6l-3.8,0l0.9,3.6
                  c0,0-0.5,2.1-0.7,2.4c-0.2,0.3,0,3.2,0,3.2l2,0.9l-1.1,2.9l1.3,2.2l-0.3,2.3l3.6,1.5l4.6,1.2l-2,2.6l-0.3,1.7l-1.1,4.2l1.2,1.5
                  l3.6-2.1l4.9,1.8l1.9,0.2l0.9,1.4l1.6-1.9l2,0.9l4.6-1.5l2.5-0.5l1.5,1.1l0.2-2.5l-1.1-1.3l0.9-1.2l0.9,0l1.1-1.5l-0.9-1.7
                  l2.4,0.7l-0.1-1.8l-5-3.7L39,39.1l0.2-1.6l-1.7-1.6l0.1-0.8l3.5-0.5l5.8-3.7l-0.1-1.3l1.1,0.6l0.9,1.6l0.8-3.8l-2.2-3.5
                  l0.3-2.6l-1.1-4.3l-1.5-0.8l0.6-3l-1.6-5.1l-2.8,0.1L42.3,6l-1.4-0.5l-2.1,1.9l-0.7,0.2l-2.5,2.5l-4.4,0.5l1-1.5l0-2.3
                  l-2.2,1.1l-2.2-1l-0.3-1.8l-5.9-1.4l1.2,2.5l1.2,1.3l-1.9,0.8L23.3,9l0.3,1.9l2,1.2l1.5,1.6l-0.3,0.5`}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </>
);

export default CountryDe;
